'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileNavigation', cobCarrierProfileNavigation);

	cobCarrierProfileNavigation.$inject = [
		'$rootScope', '$state', '$stateParams', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService', 'carrierService', 'carrierSettingsService', '$timeout'
	];

	var $rootScope,
		$state,
		$stateParams,
		subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		sessionService,
		carrierRegistrationService,
		carrierSettingsService,
		$timeout,
		carrierService;

	function cobCarrierProfileNavigation(_$rootScope_,
		_$state_,
		_$stateParams_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_,
		_carrierService_,
		_carrierSettingsService_,
		_$timeout_) {
		$rootScope = _$rootScope_;
		$state = _$state_;
		$stateParams = _$stateParams_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;
		carrierService = _carrierService_;
		carrierSettingsService = _carrierSettingsService_;
		$timeout = _$timeout_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileNavigation.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				isBroker: sessionService.isAuthorizedBrokerRead(),
				isBrokerWrite: sessionService.isAuthorizedBrokerWrite(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				isCarrier: sessionService.isAuthorizedCarrierRead(),
				statusCount: 0
			};

			scope.carrierId = $stateParams.carrierId;
			scope.brokerId = $stateParams.brokerId;
			scope.pendingViewStatusChange = '';
			scope.selectTab = selectTab;
			scope.setTab = setTab;
			scope.navigationOrder = [
				'carrierProfile.company',
				'carrierProfile.contacts',
				'carrierProfile.fleetServices',
				'carrierProfile.laneCoverage',
				'carrierProfile.taxes',
				'carrierProfile.documents',
				'carrierProfile.insurance',
				'carrierProfile.contracts'
			];

			scope.navigationHeader = {
				'carrierProfile.company': 'Company',
				'carrierProfile.contacts': 'Contacts',
				'carrierProfile.fleetServices': 'Fleet',
				'carrierProfile.laneCoverage': 'Lanes',
				'carrierProfile.taxes': 'Tax',
				'carrierProfile.documents': 'Documents',
				'carrierProfile.insurance': 'Insurance',
				'carrierProfile.contracts': 'Contracts'
			};
			scope.saveNote = saveNote;
			scope.$state = $state;
			scope.makeNavSticky = true;

			var tab = location.hash.substr(10);
			registerObserverHandlers();
			selectTab(tab, true);
			lookupCarrierStatus();
			getCarrierImpersonated();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{
						message: observerMessages.COB_OBSERVER_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
						handler: onFinishChangeView
					},
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_VIEW_LOAD, handler: onViewLoad },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_VIEW_STATUS, handler: onViewStatusChange },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_STATUS_FINISH, handler: loadFirstTab }
				]);
		}

		function onFinishChangeView(view) {
			if (view === 'profile') {
				$rootScope.firstLogin = true;
				loadFirstTab();
			} else {
				selectTab(view);
				setTab();
			}
		}

		function onViewLoad() {
			setStickyNav();
			var tab = location.hash.substr(10).split('?')[0];
			selectTab(tab, true);
		}

		function loadFirstTab() {
			if ($rootScope.firstLogin) {
				for (var i = 0; i < scope.navigationOrder.length; i++) {
					if (!navStatusHelper(scope.navigationOrder[i])) {
						if (scope.navigationOrder[i] !== $state.current.name)
							$state.go(scope.navigationOrder[i],
								{ carrierId: $stateParams.carrierId, brokerId: $stateParams.brokerId });
						break;
					}
				}
				$rootScope.firstLogin = false;
			}
		}

		function selectTab(tab, isViewLoad) {
			var next, back;
			//the order of items MATTER
			if (tab === 'next') {
				next = true;
			} else if (tab === 'back') {
				back = true;
			} else {
				scope.m.pendingTab = tab;
			}

			if (next || back) {
				for (var i = 0; i < scope.navigationOrder.length; i++) {
					if (scope.navigationOrder[i] === $state.current.name) {
						if (next) {
							i = i + 1;
						} else if (back) {
							i = i - 1;
						}
						scope.m.pendingTab = scope.navigationOrder[i];
						break;
					}
				}
			}
			if (scope.pendingViewStatusChange) {
				viewStatusChange();
			}
			if (isViewLoad) {
				scope.m.pendingTab = '';
			} else
				observerService.sendMessageToSubject(scope,
					subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
					setTab);
		}

		function setTab() {
			if (scope.m.pendingTab === $state.current.name) {
				$state.go(scope.m.pendingTab,
					{ carrierId: $stateParams.carrierId, brokerId: $stateParams.brokerId },
					{ reload: true });
				scope.m.pendingTab = '';
			} else if (scope.m.pendingTab) {
				$state.go(scope.m.pendingTab, { carrierId: $stateParams.carrierId, brokerId: $stateParams.brokerId });
				scope.m.pendingTab = '';
			}

		}

		function lookupCarrierStatus() {
			carrierRegistrationService.lookupCarrierStatus(scope.carrierId)
				.then(function(response) {
					scope.m.companyInfoComplete = response.data.companyInfoComplete;
					scope.m.contactsComplete = response.data.contactsComplete;
					scope.m.documentsComplete = response.data.documentsComplete;
					scope.m.equipmentInfoComplete = response.data.equipmentInfoComplete;
					scope.m.insuranceInfoComplete = response.data.insuranceInfoComplete;
					scope.m.laneInfoComplete = response.data.laneInfoComplete;
					scope.m.taxInfoComplete = response.data.taxInfoComplete;
					isReadyToSign();
					setCarrierNavState();
					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_CARRIER_PROFILE_STATUS_FINISH);
				});
			if ($stateParams.carrierId 
				&& ($('base').attr('href').split('/')[1] || $stateParams.brokerId || scope.m.isBroker) 
				&& !scope.m.isAdmin) {
				carrierRegistrationService.lookupContractsAndSignatures($stateParams.carrierId, $stateParams.brokerId)
					.then(loadContractsHelper);
			}
		}

		function loadContractsHelper(response) {

			for (var i = 0; i < response.data.contractSignatures.length; i++) {
				if (response.data.contractSignatures[i].signee &&! response.data.contractSignatures[i].rejected) {
					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
						'contracts');

					return;
				}
			}

		}

		function onViewStatusChange(view) {
			if (view === 'contracts') {
				scope.m.contractsComplete = true;
			} else {
				scope.pendingViewStatusChange = view;
			}

		}

		function viewStatusChange() {
			switch (scope.pendingViewStatusChange) {
			case 'company':
				scope.m.companyInfoComplete = true;
				break;
			case 'contacts':
				scope.m.contactsComplete = true;
				break;
			case 'documents':
				scope.m.documentsComplete = true;
				break;
			case 'fleetServices':
				scope.m.equipmentInfoComplete = true;
				break;
			case 'insurance':
				scope.m.insuranceInfoComplete = true;
				break;
			case 'laneCoverage':
				scope.m.laneInfoComplete = true;
				break;
			case 'taxes':
				scope.m.taxInfoComplete = true;
				break;
			}
            
			setCarrierNavState();
			navStatusHelper();
			scope.pendingViewStatusChange = '';

			if (!scope.m.readyTosign) {
				if (isReadyToSign()) {
					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_CARRIER_PROFILE_READY_TO_SIGN);
					carrierRegistrationService.sendProfileCompleteNotification($stateParams.carrierId);
				}
			}
		}

		function navStatusHelper(tab) {
			switch (tab) {
			case 'carrierProfile.company':
				return scope.m.companyInfoComplete;
			case 'carrierProfile.contacts':
				return scope.m.contactsComplete;
			case 'carrierProfile.fleetServices':
				return scope.m.equipmentInfoComplete;
			case 'carrierProfile.laneCoverage':
				return scope.m.laneInfoComplete;
			case 'carrierProfile.taxes':
				return scope.m.taxInfoComplete;
			case 'carrierProfile.documents':
				return scope.m.documentsComplete;
			case 'carrierProfile.insurance':
				return scope.m.insuranceInfoComplete;
			default:
				return false;
			}
		}

		function isReadyToSign() {
			scope.m.statusCount = 0;
			if (scope.m.companyInfoComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.contactsComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.documentsComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.equipmentInfoComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.insuranceInfoComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.laneInfoComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.taxInfoComplete)
				scope.m.statusCount = scope.m.statusCount + 1;
			if (scope.m.statusCount === 7) {
				scope.m.readyTosign = true;
				if (sessionService.getCarrierReadyToSign() === false) {
					scope.m.readyToSign = sessionService.setCarrierReadyToSign(true);
				}            
			} else {
				scope.m.readyTosign = false;
				scope.m.readyToSign = sessionService.setCarrierReadyToSign(false);
			}

			return scope.m.readyTosign;
		}

		function saveNote() {
			if (scope.m.carrierNotesChange) {
				if (scope.m.carrierNotes) {
					carrierService.updateCarrierNote(scope.m.carrierId, scope.m.carrierNotes)
						.then(function() {
							scope.m.editingNotes = false;
							scope.m.carrierNotesChange = false;
						});
				} else {
					carrierService.deleteCarrierNote(scope.m.carrierId)
						.then(function() {
							scope.m.editingNotes = false;
							scope.m.carrierNotesChange = false;
						});
				}
			} else {
				scope.m.editingNotes = false;
			}

		}

		function setStickyNav() {
			var Ylocation = Ylocation || 0;
			$('.carrier-profile-wrapper')
				.bind('scroll',
					function() {
						var currentLocation = $(this).scrollTop();
						$(this).addClass('full-length');
						$('.carrier-profile').addClass('full-length');
						if (currentLocation >= Ylocation) {
							scope.makeNavSticky = false;
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_SCROLL,
									scope.makeNavSticky);
							Ylocation = currentLocation;
						} else {
							scope.makeNavSticky = true;
							$(this).removeClass('full-length');
							$('.carrier-profile').removeClass('full-length');
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_SCROLL,
									scope.makeNavSticky);
							Ylocation = currentLocation;
						}
						scope.$apply();
					});
		}

		function setCarrierNavState() {
			var navState = {companyInfoComplete: scope.m.companyInfoComplete,
				contactsComplete: scope.m.contactsComplete,
				documentsComplete: scope.m.documentsComplete,
				equipmentInfoComplete: scope.m.equipmentInfoComplete,
				insuranceInfoComplete: scope.m.insuranceInfoComplete,
				laneInfoComplete: scope.m.laneInfoComplete,
				taxInfoComplete: scope.m.taxInfoComplete
			};
			sessionService.setCarrierNavState(navState);
		}

		function getCarrierImpersonated() {
			if (scope.carrierId) {
				if (scope.m.isAdmin && !scope.brokerId) {
					var carrier = sessionService.getCarrierImpersonated();
					scope.m.dotNumber = carrier.dotNumber;
					scope.m.intrastateNumber = carrier.intrastateNumber;
					scope.m.carrierName = carrier.carrierName;

					return;
				}
				carrierService.getCarrierDetails(scope.carrierId, scope.brokerId)
					.then(function (response) {
						scope.m.carrierId = response.data.carrierDetails.carrierId;
						scope.m.businessUnitId = response.data.carrierDetails.businessUnitId;
						if (response.data.carrierDetails.dbaName) {
							scope.m.carrierName = response.data.carrierDetails.dbaName;
						}
						else {
							scope.m.carrierName = response.data.carrierDetails.legalName;
						}
						scope.m.dotNumber = response.data.carrierDetails.dot;
						scope.m.intrastateNumber = response.data.carrierDetails.intrastateCode;
						scope.m.carrierNotes = response.data.carrierDetails.notes;
						scope.m.carrierStatus = response.data.carrierDetails.status;

						if (scope.m.isBroker) {
							carrierRegistrationService.lookupUrlsByCategory(scope.m.businessUnitId)
								.then(function (response) {
									scope.m.carrierWatchUrl = response.data.url;
								});
						}
					});
			} else {
				if (scope.m.isCarrier) {
					carrierSettingsService.lookupCarrierProfileModal(scope.carrierId).then(function (response) {
						if (response.data.dbaName) {
							scope.m.carrierCompanyName = response.data.dbaName;
						} else {
							scope.m.carrierCompanyName = response.data.legalName;
						}
					});
				}
			}
		}
	}
})();
